import { ErrorMessage } from '@hookform/error-message';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import Button from '../../components/ui/Button';
import CustomInput from '../../components/ui/CustomInput';
import CommanPhoneNumber from '../../components/ui/PhoneNumber';
import { ApiConstants } from '../../constants/ApiConstants';
import { Routes } from '../../constants/RouteConstants';
import useMakeRequest from '../../utils/ApiHelper';
import InviteHouseHoldValidation from '../../validations/household/invitehousehold';

interface householdInputs {
    name: string;
    email: string,
    household_id: string,
    member_type: string,
    phone_number: string,
    phone_country_code: string,
    income: string,
    monthly_work_hour: string,
    send_invite: boolean,
};




const EditHouseholdMember = () => {
    const navigate = useNavigate();
    const getHhData = useMakeRequest();
    const hhInvite = useMakeRequest();
    const [sendInviteStatus, setInviteStatus] = useState(true)

    const { register, watch, setValue, formState: { errors }, handleSubmit, trigger, reset } = useForm<householdInputs>({
        mode: 'onChange', resolver: yupResolver(InviteHouseHoldValidation)
    });

    const handlePhoneNumber = (value: any, code: any, phone: any) => {
        setValue('phone_country_code', code?.dialCode);
        setValue('phone_number', phone);
        trigger("phone_number")
    }


    const handleSelectChange = (selectedOption: any) => {
        setValue("household_id", selectedOption ? selectedOption.value : "");
        trigger("household_id")
    };


    const memberType = [
        { value: '1', label: 'Partner' },
        { value: '2', label: 'Roommate' },
        { value: '3', label: 'Family member' },
    ];


    const handleSelectMemberType = (selectedOption: any) => {
        trigger("income");
        trigger("monthly_work_hour");
        setValue("member_type", selectedOption ? selectedOption.value : "");
        trigger("member_type");

    };

    useEffect(() => {
        getHhData.makeRequest({ url: ApiConstants?.GetHousehold, payload: { show_all: true } })
        setValue('send_invite', sendInviteStatus)
    }, [])

    const onSubmit = (data: any) => {
        const payload = {
            ...data,
            income: data?.income ? data.income.replace(/,/g, '') : '',
        }
        toast.promise(
            hhInvite.makeRequest({ url: ApiConstants?.inviteHousehold, payload }),
            {
                loading: 'Processing...',
                success: (data: any) => data.message,
                error: (error: any) => error.message,
            }
        );
    }

    const handleCheckBox = () => {
        const newStatus = !sendInviteStatus;
        trigger('email');
        trigger('phone_number');
        trigger('member_type');
        trigger('monthly_work_hour');
        trigger('income');
        trigger('household_id')
        trigger('name');
        setValue('send_invite', newStatus);
        setInviteStatus(newStatus);
    }

    useEffect(() => {
        if (hhInvite?.data) {
            navigate(Routes?.ManageHousehold)
            reset();
        }
    }, [hhInvite?.data])

    useEffect(() => {
        console.log("getHhData?.data?.data; ", getHhData)
        if (getHhData?.status) {
            setValue("household_id", getHhData?.data?.data?.[0]?.value);
            // setValue("income", getHhData?.data?.data?.[0]?.value);
        }
    }, [getHhData?.data])

    return (

        <div className="">
            <header role="banner">
                <h1 className='head-title'><a onClick={() => navigate(-1)} className='cursor-pointer' aria-label="Go back"><i className='icon-back-arw' aria-hidden="true"></i></a>Add/Invite Household Members</h1>
            </header>
            <main id="main-content">
                <form onSubmit={handleSubmit(onSubmit)} className='page-padding-x'>
                <>
                    <div className="mb-3 com-input-grp">
                        <label className="form-label">Household Name<span className='label-star'>*</span></label>
                        <div className="com-input-grp">
                            <div className='custom-select'>
                                <Select
                                    value={{ value: getHhData?.data?.data?.[0]?.value, label: getHhData?.data?.data?.[0]?.label }}
                                    options={getHhData?.data?.data}
                                    className="com-r-select"
                                    classNamePrefix="com-r-select"
                                    placeholder="Please select household name"
                                    onChange={handleSelectChange}
                                    closeMenuOnScroll={true}
                                    closeMenuOnSelect={true}
                                    isLoading={getHhData?.loading}
                                />
                            </div>
                            <ErrorMessage errors={errors} name="household_id" render={({ message }) => <p className='valid-error'>{message}</p>} />
                        </div>
                    </div>

                    <div className="mb-3 com-input-grp">
                        <label className="form-label">Name<span className='label-star'>*</span></label>
                        <input type="text" className="form-control" placeholder='Enter name' {...register('name')} />
                        <ErrorMessage errors={errors} name="name" render={({ message }) => <p className='valid-error'>{message}</p>} />
                    </div>
                    {
                        sendInviteStatus && (
                            <>
                                <div className="mb-3 com-input-grp">
                                    <label className="form-label">Email<span className='label-star'>*</span></label>
                                    <div className='position-relative icon-input-wrap'>
                                        <input type="email" className="form-control" placeholder='Enter email' value={watch('email')}   {...register('email')} />
                                    </div>
                                    <ErrorMessage errors={errors} name="email" render={({ message }) => <p className='valid-error'>{message}</p>} />
                                </div>

                                <div className="mb-3 com-input-grp">
                                    <label className="form-label">Mobile Number</label>
                                    <div className='phone-code-select-wrap'>
                                        <CommanPhoneNumber handleMobileNumber={handlePhoneNumber} value={`${watch('phone_country_code')} ${watch('phone_number')}`} />
                                    </div>
                                    <ErrorMessage errors={errors} name="phone_number" render={({ message }) => <p className='valid-error'>{message}</p>} />
                                </div>
                            </>
                        )
                    }

                    <div className="mb-3 com-input-grp">
                        <label className="form-label">Member Type<span className='label-star'>*</span></label>
                        <div className='custom-select'>
                            <Select
                                options={memberType}
                                className="com-r-select"
                                classNamePrefix="com-r-select"
                                placeholder="Please select member type"
                                onChange={handleSelectMemberType}
                                closeMenuOnScroll={true}
                                closeMenuOnSelect={true}
                            />
                            <ErrorMessage errors={errors} name="member_type" render={({ message }) => <p className='valid-error'>{message}</p>} />
                        </div>
                    </div>

                    {
                        <>
                            <CustomInput
                                label="Income"
                                type="text"
                                placeholder="00.00"
                                {...register('income')}
                                error={errors.income?.message}
                                onInput={(e: any) => {
                                    let value = e.target.value;

                                    // remove commas first
                                    value = value.replace(/,/g, '');

                                    // allow only numbers and decimal
                                    value = value.replace(/[^0-9.]/g, '');

                                    // allow only one decimal
                                    const decimalCount = value.split('.').length - 1;
                                    if (decimalCount > 1) {
                                        const parts = value.split('.');
                                        value = parts[0] + '.' + parts.slice(1).join('');
                                    }

                                    let parts = value.split('.');

                                    // limit integer length
                                    if (parts[0].length > 7) {
                                        parts[0] = parts[0].substring(0, 7);
                                    }

                                    // limit decimal to 2
                                    if (parts[1]) {
                                        parts[1] = parts[1].substring(0, 2);
                                    }

                                    // add commas to integer part
                                    parts[0] = Number(parts[0]).toLocaleString('en-US');

                                    e.target.value = parts.join('.');
                                }}
                            />
                            <div className="mb-3 com-input-grp">
                                <label className="form-label">Income<i className='icon-info ms-2'></i></label>
                                <div className='income-field'>
                                    <span>$</span>
                                    <input type="text" className="form-control" placeholder='00.00' {...register("income")}
                                        onInput={(e: any) => {
                                            let inputValue = e.target.value;
                                            inputValue = inputValue.replace(/[^0-9.]/g, '');
                                            const decimalCount = inputValue.split('.').length - 1;
                                            if (decimalCount > 1) {
                                                const parts = inputValue.split('.');
                                                inputValue = parts[0] + '.' + parts.slice(1).join('');
                                            }
                                            const parts = inputValue.split('.');
                                            if (parts[0].length > 7) {
                                                parts[0] = parts[0].substring(0, 7);
                                            }
                                            if (parts.length > 1) {
                                                parts[1] = parts[1]?.substring(0, 2);
                                            }
                                            inputValue = parts.join('.');
                                            e.target.value = inputValue;
                                        }} />
                                </div>
                                <ErrorMessage errors={errors} name="income" render={({ message }) => <p className='valid-error'>{message}</p>} />
                            </div>

                            <div className="mb-3 com-input-grp">
                                <label className="form-label">Hours of Employment (Monthly)<i className='icon-info ms-2'></i></label>
                                <div className='income-field'>
                                    <input type="text" className="form-control" placeholder='Enter hours'  {...register('monthly_work_hour')}
                                        onInput={(e: any) => {
                                            let value = e.target.value;

                                            // Remove non-digits
                                            value = value.replace(/\D/g, "");

                                            // Prevent multiple leading zeros
                                            if (value === "00" || value === "000") {
                                                value = "0";
                                            }

                                            // If starts with 0 and has more digits, remove leading zero
                                            if (value.length > 1 && value.startsWith("0")) {
                                                value = value.replace(/^0+/, "");
                                            }

                                            // Limit to 3 digits
                                            if (value.length > 3) {
                                                value = value.slice(0, 3);
                                            }

                                            // Cap max value to 720
                                            if (Number(value) > 720) {
                                                value = "720";
                                            }

                                            e.target.value = value;
                                        }}
                                    />
                                </div>
                                <ErrorMessage errors={errors} name="monthly_work_hour" render={({ message }) => <p className='valid-error'>{message}</p>} />
                            </div>


                        </>
                    }

                    <div className='d-flex align-items-center switch-area'>
                        <label>Send Invite</label>
                        <div className="form-check form-switch ms-auto">
                            <input className="form-check-input" type="checkbox" onClick={handleCheckBox} checked={sendInviteStatus} />
                        </div>
                    </div>


                    {/* <button className='com-btn my-5 mx-auto' type='submit' >Continue</button> */}
                    {/* <Button loading={hhInvite?.loading} text="Continue" className='com-btn my-5' type="submit" /> */}
                    <Button className='com-btn my-5' type="submit" text="submit" loading={hhInvite?.loading}>Continue</Button>
                </>
                {/* )
                } */}





            </form>
            </main>

        </div>
    )
}

export default EditHouseholdMember
